import config from '../config';

export const dashboardApi = {
  async fetchDashboardData() {
    try {
      const endpoints = [
        '/sales-orders',
        '/purchase-orders',
        '/production-requests',
        '/inventory/all',
        '/pm-inventory/stock-overview'
      ];

      const requests = endpoints.map(endpoint =>
        fetch(`${config.API_BASE_URL}${endpoint}`)
          .then(res => res.ok ? res.json() : { data: [] })
          .catch(() => ({ data: [] }))
      );

      const [salesOrders, purchaseOrders, productionRequests, inventory, pmInventory] = await Promise.all(requests);
      // console.log("api inventory: " + JSON.stringify(inventory));
      return {
        salesOrders: salesOrders.data || salesOrders || [],
        purchaseOrders: purchaseOrders.data || purchaseOrders || [],
        productionRequests: productionRequests.data || productionRequests || [],
        inventory: inventory.data || inventory || [],
        pmInventory: pmInventory.data || pmInventory || []
      };
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
      return {
        salesOrders: [],
        purchaseOrders: [],
        productionRequests: [],
        inventory: [],
        pmInventory: []
      };
    }
  },

  async generateDispatchNote(dispatchData) {
    try {
      const response = await fetch(`${config.API_BASE_URL}/dispatch-notes`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(dispatchData)
      });

      if (!response.ok) throw new Error('Failed to generate dispatch note');
      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Failed to generate dispatch note');
    }
  }
};

export const notificationGenerators = {
  generateLowStockNotifications(inventory) {
    const items = Array.isArray(inventory) ? inventory : inventory?.data || [];
    return items
      .filter(item => item.currentStock <= item.minStock)
      .map(item => ({
        id: `stock-${item._id}`,
        type: item.currentStock === 0 ? 'danger' : 'warning',
        title: item.currentStock === 0 ? 'Out of Stock' : 'Low Stock Alert',
        message: `${item.productName} ${item.currentStock === 0
            ? 'is out of stock'
            : `is running low (${item.currentStock} ${item.unit})`
          }`,
        timestamp: new Date()
      }));
  },

  generateLowPackingMaterialStockNotifications(pmInventory) {
    const items = Array.isArray(pmInventory) ? pmInventory : pmInventory?.data || [];
    return items
      .filter(item => {
        const availableStock = item.totalAvailableStock || 0;
        const reorderLevel = item.packingMaterial?.reorderQuantity || 0;
        return availableStock <= reorderLevel;
      })
      .map(item => {
        const availableStock = item.totalAvailableStock || 0;
        // const reorderLevel = item.packingMaterial?.reorderQuantity || 0;
        return {
          id: `pm-stock-${item.packingMaterial._id}`,
          type: availableStock === 0 ? 'danger' : 'warning',
          title: availableStock === 0 ? 'Packing Material Out of Stock' : 'Packing Material Low Stock Alert',
          message: `${item.packingMaterial.name} ${availableStock === 0
              ? 'is out of stock'
              : `is running low (${availableStock} ${item.packingMaterial.quantityUnit || 'pcs'})`
            }`,
          timestamp: new Date()
        };
      });
  },

  generateOverdueOrderNotifications(salesOrders) {
    const now = new Date();
    return salesOrders
      .filter(order => new Date(order.EDD) < now && !['Delivered', 'Cancelled'].includes(order.status))
      .map(order => ({
        id: `overdue-so-${order._id}`,
        type: 'danger',
        title: 'Overdue Sales Order',
        message: `Order ${order.orderNumber} is overdue`,
        timestamp: new Date(order.EDD)
      }));
  }
};
